module.exports = __webpack_public_path__ + "index/img/level_icon.537f43bc.png";